import { jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Box } from "braid-design-system";
import { analyticsMobileMenuEvents } from "../../../EmployerFooter/AuthenticatedFooterLinks/AuthenticatedFooterLinks.mjs";
import { useEmployerHeaderContext } from "../../EmployerHeader.mjs";
import { AccordionMenu } from "../AccountDropdown/AccountDropdown.mjs";
import { MobileNavigation } from "../Navigation/MobileNavigation.mjs";
import { translations } from "../../../../EmployerHeader/components/MobileMenuDropdown/.vocab/index.mjs";
import { root } from "./MobileMenuDropdown.css.mjs";
const MobileMenuDropdown = ({
  id,
  activeTabId,
  activeSubTabId,
  items,
  onToggleButtonClick,
  linkRenderer
}) => {
  const { t } = useTranslations(translations);
  const { handleInteractionTracking } = useEmployerHeaderContext();
  const handleDropDownTogggle = (isToggledOn) => {
    const analyticsEvent = isToggledOn ? analyticsMobileMenuEvents.menuToggleClosed : analyticsMobileMenuEvents.menuToggleOpen;
    handleInteractionTracking(analyticsEvent);
  };
  return /* @__PURE__ */ jsx(Box, { className: root, children: /* @__PURE__ */ jsx(
    AccordionMenu,
    {
      id: `mobile-menu-toggle${id ? `-${id}` : ""}`,
      label: t("Menu"),
      toggleScrollLockTargetId: "employer-header-mobile-navigation",
      onToggleButtonClick,
      onDropDownToggle: handleDropDownTogggle,
      render: ({ onMenuItemClick }) => /* @__PURE__ */ jsx(
        MobileNavigation,
        {
          activeTabId,
          activeSubTabId,
          items,
          onToggleButtonClick,
          onCloseMobileMenu: onMenuItemClick,
          linkRenderer
        }
      )
    }
  ) });
};
export {
  MobileMenuDropdown
};
